import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useState } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import FacetDataContext from '~/contexts/FacetDataContext';
import FilterDrawer from './FilterDrawer';
import RangeSlider from './RangeSlider';
import type WithClassName from './WithClassName';

function SeatingCapacity({ className }: WithClassName) {
  const { trackEvent } = useContext(AnalyticsContext);
  const { facetData } = useContext(FacetDataContext);
  const { appliedFilters, updateRangeFilter } = useContext(
    AppliedFiltersContext
  );
  const [show, setShow] = useState(false);

  return (
    <FilterDrawer
      className={className}
      dataQa="facet-seating-capacity"
      facetContent
      facetName="Seating Capacity"
      show={show}
      onToggle={() => {
        setShow(!show);
      }}
    >
      <div className="gap-32 grid px-24 py-32">
        <RangeSlider
          data-analytics-id="adjust-seating-capacity-range"
          format="number"
          isShowing={show}
          id="facet-seating-capacity"
          label="Seats"
          dualRange
          min={facetData.seatingCapacity?.min}
          max={facetData.seatingCapacity?.max}
          initialValues={[
            appliedFilters.seatingCapacity?.min ??
              facetData.seatingCapacity?.min ??
              0,
            appliedFilters.seatingCapacity?.max ??
              facetData.seatingCapacity?.max ??
              0
          ]}
          onUpdate={v => {
            updateRangeFilter({
              filterKey: 'seatingCapacity',
              value: {
                min: v?.[0] ?? facetData.seatingCapacity?.min,
                max: v?.[1] ?? facetData.seatingCapacity?.max
              }
            });
            trackEvent('Filter seating capacity', {
              min: v?.[0] ?? facetData.seatingCapacity?.min,
              max: v?.[1] ?? facetData.seatingCapacity?.max
            });
          }}
        />
      </div>
    </FilterDrawer>
  );
}

export default SeatingCapacity;
